'use strict';

angular.module('ClinicApp').factory('GrowlService', function(growl) {
  var messagesToSuppress = [];

  // Returns `true` if the given message need to be suppressed.
  function _isMessageToSuppress(message) {
    // Suppress the message once.
    return !!_.remove(messagesToSuppress, function(m) {
      return m == message;
    }).length;
  }

  return {
    error: function(message, options) {
      if (_isMessageToSuppress(message)) {
        return;
      }
      growl.error(message, _.defaults(options || {}, {
        title: 'Something went wrong',
      }));
    },

    success: function(message, options) {
      if (_isMessageToSuppress(message)) {
        return;
      }
      growl.success(message, _.defaults(options || {}, {
        title: 'Success',
      }));
    },
    suppress: {
      addMessage: function(message) {
        if (!_.includes(messagesToSuppress, message)) {
          messagesToSuppress.push(message);
        }
      },

      removeMessage: function(message) {
        _.remove(messagesToSuppress, function(m) {
          return m == message;
        });
      },
    },
  };
});
